import { useEffect } from "react";
import { termsData } from "./helpers";
import SEO from "components/SEO";

function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>  
    <SEO />
      <div className="container">
        <div className="conditions">
          <h1 className="title font-title-lg fw-700">Privacy Policy</h1>
          <p className="desc font-body-md2 leading-5 mt-1">
            Effective date: 12 Jan 2025
          </p>

          <div className="terms-container mt-6">
            {termsData.map((section, index) => (
              <div className="section mb-6" key={index}>
                <h2 className="sub-title font-title-xs fw-700 mb-3">
                  {`${index + 1}. ${section.title}`}
                </h2>

                {/* description */}
                {section.description &&
                  section.description.map((desc, i) => (
                    <p
                      key={`desc-${i}`}
                      className="font-body-md2 leading-6 mb-3 description"
                    >
                      {desc}
                    </p>
                  ))}

                {/* points */}
                {section.points && (
                  <ul className="lists pl-5 mb-3">
                    {section.points.map((point, i) => (
                      <li
                        key={`point-${i}`}
                        className="list-terms font-title-xs fw-400 mb-1"
                      >
                        {point}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Footer Description */}
                {section.footerDescription &&
                  section.footerDescription.map((desc, i) => (
                    <p
                      key={`desc2-${i}`}
                      className="font-body-md2 leading-6 mb-3 footer"
                    >
                      {desc}
                    </p>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Privacy;
